<template>
    <div>
        <div class="row">
            <div class="col-sm-3" v-for="(crop, index) in crops" :key="index">
                <div class="dcy-list-item dcy-card">
                    <router-link :to="{ name: 'offtaker.crop', params: { id: crop.id } }">
                        <div class="dcy-list-item__header">
                            <span v-if="crop.images && crop.images[0]">
                                <img :src="crop.images[0].url" alt="" class="img-responsive" />
                            </span>
                            <span v-else>
                                <img :src="`${$baseImageUrl}/banners/auth_bg.jpg`" />
                            </span>
                            <div class="dcy-list-item__overlay">
                            <div class="name-title">
                                <span class="name-logo">{{crop.farm.farmer_name | initials}}</span>
                                <span class="name">{{crop.farm.farmer_name}}</span>
                            </div>
                            </div>
                        </div>
                        <div class="dcy-list-item__body">
                            <div class="title">
                            <h6>{{crop.name}}</h6>
                            <span>{{crop.kg_yield/1000}} tons . ₦{{crop.kg_price/1000 | formatAmount}}/ton</span>
                            </div>
                            <div class="farming-stage">
                            <div class="farming-stage__children">
                                <span>Farming stage</span>
                                <span>{{crop.currentStage.name}}</span>
                            </div>
                            <div class="farming-stage__progress">
                                <div class="is-progressing progress-count" :style="{width: `${crop.currentStage.progress}%`}"></div>
                            </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
            
            <div v-if="crops.length === 0 && !gettingCrops" class="col-12">
                <empty-component>
                    <p>No other crops by this farmer</p>
                </empty-component>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyComponent from '@/components/utils/EmptyComponent'
export default {
    props: ['crops', 'gettingCrops'],
    data() {
        return {

        }
    },
    methods: {
        getCurrentStage() {

        }
    },
    components: {
        EmptyComponent
    }
}
</script>

<style>

</style>
